(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('input[type=number].number--buttons-input').each(function () {
		var field = $(this);
		var fieldWrapper = field.parent();
		var maxValue = field.attr('max') || false;
		var minValue = field.attr('min') || false;
		var step = field.attr('step') || 1;

		var inc = $('<a href="#">+</a>').appendTo(fieldWrapper);
		var dec = $('<a href="#">-</a>').prependTo(fieldWrapper);

		fieldWrapper.addClass('number--buttons');

		inc.on('click', function(e) {
			e.preventDefault();

			var value = parseFloat(field.val()) || 0;

			if ((value < maxValue) || !maxValue) {
				value = value + step;
			}

			field.val(value);
		});

		dec.on('click', function(e) {
			e.preventDefault();

			var value = parseFloat(field.val()) || 0;

			if ((value > minValue) || !minValue) {
				value = value - step;
			}

			field.val(value);
		});
	});

})();